import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://6a8b825b6a480f4890f077b03ba6c172@o4507178674225152.ingest.us.sentry.io/4510043249573888',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})
